import React from 'react';
import { Link } from 'react-router-dom';
const HeroSection = () => {
  return <div className="relative bg-[#1a3a6c] text-white" data-id="element-131">
      <div className="absolute inset-0 z-0" data-id="element-132">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fN6ewoxouk1ZsMaYme3RQr/01._Hero_image.webp" alt="Modern kitchen with appliances and family" className="w-full h-full object-cover opacity-30" data-id="element-133" />
      </div>
      <div className="container mx-auto px-4 py-20 md:py-28 relative z-10" data-id="element-134">
        <div className="max-w-3xl" data-id="element-135">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-136">
            Fast, Reliable Appliance Repairs Across the UK
          </h1>
          <p className="text-lg md:text-xl mb-8" data-id="element-137">
            Expert engineers, fixed-price repairs, and exceptional service for
            all your home appliances.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-138">
            <Link to="/service-coverage" className="bg-[#f97316] hover:bg-[#ea580c] text-white font-bold py-3 px-6 rounded-md text-center transition-colors" data-id="element-139">
              Our Services
            </Link>
            <Link to="/contact-us" className="bg-transparent hover:bg-white/10 text-white font-bold py-3 px-6 rounded-md border-2 border-white text-center transition-colors" data-id="element-140">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default HeroSection;